import { Helmet } from 'react-helmet';

interface PageMetadataProps {
    title: string;
    description?: string;
    image?: string;
}

const PageMetadata: React.FC<PageMetadataProps> = ({ title, description, image }) => {
    const pageDescription = description || 'Portal único para desenvolvedores da Secretaria do Tesouro Nacional.';
    const pageImage = image || `${window.location.origin}${process.env.PUBLIC_URL}/logo512.png`;

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={pageDescription} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={pageDescription} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={window.location.href} />
            <meta property="og:image" content={pageImage} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={pageDescription} />
            <meta name="twitter:image" content={pageImage} />
        </Helmet>
    );
};

export default PageMetadata;